
export function shallowEqualArray<T>(a: T[], b: T[]): boolean {
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i++){
        if (a[i] !== b[i])
            return false;
    }
    return true;
}


/**
 * Gets the distinct items in a list, as determined by the key.  Items are returned in the same order as the input array.
 */
export function distinct<T, KV>(items: T[], keySelector: (item: T) => KV){
    const addedKeys = new Set<KV>();
    const result: T[] = [];
    for (let item of items){
        const key = keySelector(item);
        if (!addedKeys.has(key)){
            result.push(item);
            addedKeys.add(key);
        }
    }
    return result;
}

export function zip<TA,TB,T>(itemsA: TA[], itemsB: TB[], selector: (a: TA, b: TB) => T): T[] {
    let result: T[] = [];
    const length = Math.min(itemsA.length, itemsB.length);
    for (let i = 0; i < length; i++)
        result.push(selector(itemsA[i], itemsB[i]));
    return result;
}